import { ArrangementCase } from "../types";

export const demoArrangementCase: ArrangementCase = {
  id: "arr-monarch-maria-hernandez",
  funeralHomeId: "fh-monarch",
  source: "monarch_homepage",
  status: "needs_director_review",
  intent: "immediate_need",
  createdAt: "2026-07-05T14:18:00.000Z",
  updatedAt: "2026-07-05T14:24:00.000Z",
  planner: {
    firstName: "Elena",
    lastName: "Hernandez",
    phone: "(954) 555-0188",
    email: "elena.hernandez@example.com",
    relationshipToDecedent: "Daughter",
    preferredContactMethod: "text",
  },
  decedent: {
    firstName: "Maria",
    middleName: "Elena",
    lastName: "Hernandez",
    preferredName: "Maria",
    dateOfBirth: "1948-02-12",
    dateOfDeath: "2026-07-04",
    biographyDraft:
      "Maria Elena Hernandez was a beloved mother, grandmother, parish volunteer, and steady presence for her family. She loved Sunday dinners, orchids, and making every guest feel known.",
  },
  disposition: {
    type: "burial",
    cemeteryName: "",
    notes: "Family expects burial and would like Monarch to help confirm cemetery details.",
  },
  servicePlan: {
    style: "faith_based",
    faithTradition: "Catholic",
    expectedGuestCount: 85,
    livestreamRequested: true,
    receptionRequested: true,
    events: [
      {
        id: "event-visitation",
        type: "visitation",
        title: "Visitation",
        date: "2026-07-09",
        startTime: "17:00",
        endTime: "20:00",
        locationName: "Monarch Funeral Home & Cremation Services",
        locationAddress: "2950 N State Rd 7, Margate, FL 33063",
      },
      {
        id: "event-mass",
        type: "mass",
        title: "Funeral Mass",
        date: "2026-07-10",
        startTime: "10:30",
        locationName: "St. Elizabeth Ann Seton Catholic Church",
        locationAddress: "1401 Coral Ridge Dr, Coral Springs, FL 33071",
      },
      {
        id: "event-graveside",
        type: "graveside",
        title: "Graveside Committal",
        date: "2026-07-10",
        startTime: "12:15",
        locationName: "Cemetery to be confirmed",
        notes: "Family requested Monarch confirmation.",
      },
      {
        id: "event-reception",
        type: "reception",
        title: "Family Reception",
        date: "2026-07-10",
        startTime: "13:30",
        locationName: "Monarch reception partner venue",
        notes: "Small reception for close family and friends.",
      },
    ],
  },
  categoryProgress: [
    {
      id: "big_picture",
      title: "Big Picture",
      summary: "Immediate-need burial path with Monarch bringing Maria into care.",
      status: "complete",
      fields: ["Disposition path", "Funeral home", "Bring loved one into care"],
      missingFields: [],
      directorReviewNeeded: false,
    },
    {
      id: "care",
      title: "Caring For Loved One",
      summary: "Family wants viewing-ready care, clothing guidance, and final makeup notes.",
      status: "director_help",
      fields: ["Sanitary care", "Viewing preference", "Clothing", "Hair and makeup"],
      missingFields: ["Final clothing instructions"],
      directorReviewNeeded: true,
    },
    {
      id: "caskets_urns_keepsakes",
      title: "Caskets, Urns, Keepsakes",
      summary: "Oak casket selected; keepsake requests captured without checkout pressure.",
      status: "complete",
      fields: ["Casket", "Service folder", "Keepsake requests"],
      missingFields: [],
      directorReviewNeeded: true,
    },
    {
      id: "events",
      title: "Events",
      summary: "Visitation, Funeral Mass, graveside committal, and reception drafted.",
      status: "complete",
      fields: ["Visitation", "Funeral Mass", "Graveside", "Reception"],
      missingFields: [],
      directorReviewNeeded: true,
    },
    {
      id: "people_helping",
      title: "People Helping",
      summary: "Family wants Monarch help confirming clergy and pallbearers.",
      status: "missing",
      fields: ["Clergy", "Speakers", "Pallbearers", "Musicians"],
      missingFields: ["Officiant", "Pallbearers"],
      directorReviewNeeded: true,
    },
    {
      id: "personal_touches",
      title: "Personal Touches",
      summary: "Orchids, Catholic music, family photos, and peaceful garden tone.",
      status: "director_help",
      fields: ["Music", "Flowers", "Video tribute", "Memory table"],
      missingFields: ["Final portrait photo"],
      directorReviewNeeded: true,
    },
    {
      id: "printed_online",
      title: "Printed And Online",
      summary: "Digital service folder and guestbook are draft-ready; print follows review.",
      status: "complete",
      fields: ["Programs", "Guestbook", "Obituary", "Online memorial hub"],
      missingFields: [],
      directorReviewNeeded: true,
    },
    {
      id: "transportation",
      title: "Transportation",
      summary: "Hearse and family-car timing should be reviewed with cemetery schedule.",
      status: "director_help",
      fields: ["Hearse", "Family car", "Procession", "Escort"],
      missingFields: ["Procession route"],
      directorReviewNeeded: true,
    },
    {
      id: "cemetery_resting_place",
      title: "Cemetery And Resting Place",
      summary: "Burial expected, but cemetery location still needs confirmation.",
      status: "missing",
      fields: ["Cemetery", "Grave space", "Marker", "Graveside setup"],
      missingFields: ["Cemetery name"],
      directorReviewNeeded: true,
    },
    {
      id: "reception",
      title: "Reception",
      summary: "Small partner-venue reception requested for close family and friends.",
      status: "complete",
      fields: ["Venue", "Guest count", "Food and beverage", "Gathering style"],
      missingFields: [],
      directorReviewNeeded: true,
    },
    {
      id: "paperwork_payment",
      title: "Paperwork And Payment",
      summary: "Statement draft ready; signatures and final GPL/CPL pricing remain open.",
      status: "missing",
      fields: ["Death certificates", "Signatures", "Insurance", "Payments"],
      missingFields: ["Purchaser signature", "Final GPL/CPL pricing"],
      directorReviewNeeded: true,
    },
  ],
  merchandiseSelections: [
    {
      productId: "classic-oak-tribute",
      category: "casket",
      quantity: 1,
    },
    {
      productId: "monarch-gold-folder",
      category: "service_folder",
      quantity: 85,
      notes: "Digital folder first, print later if final photo is ready.",
    },
  ],
  digitalFolder: {
    enabled: true,
    templateId: "monarch-gold",
    title: "A Celebration of Life for Maria Elena Hernandez",
    orderOfService: [
      "Musical Prelude",
      "Opening Prayer",
      "Scripture Reading",
      "Reflections from Family and Friends",
      "Musical Selection",
      "Eulogy",
      "Closing Prayer",
      "Recessional",
    ],
    readings: ["Psalm 23", "John 14:1-3"],
    musicSelections: ["Ave Maria", "How Great Thou Art"],
    pallbearers: [],
    honoraryPallbearers: [],
    acknowledgments:
      "The Hernandez family is grateful for the prayers, calls, meals, and every act of kindness.",
    closingMessage:
      "Guests are invited to share memories through the digital guestbook and join the family for a reception after the committal.",
    qrEnabled: true,
    status: "draft_ready",
  },
  guestbook: {
    enabled: true,
    allowPhotos: true,
    allowPrivateMessages: true,
    allowPublicMessages: true,
    requireEmail: true,
    requirePhone: true,
    consentCopyVersion: "monarch-demo-v1",
  },
  keepsakes: [
    {
      productId: "embossed-folder-bundle",
      quantity: 12,
      requestedBy: "family",
      status: "requested",
    },
    {
      productId: "memorial-tree-gift",
      quantity: 1,
      requestedBy: "guest",
      status: "requested",
    },
  ],
  estimate: {
    subtotalLabel: "Estimated range · Director review required",
    disclaimer:
      "Selections are not final until confirmed with Monarch. A licensed funeral director will confirm pricing, availability, and required disclosures.",
    requiresDirectorReview: true,
  },
  paperwork: {
    status: "needs_karen_review",
    lovedOneName: "Maria Elena Hernandez",
    dateOfPassingLabel: "July 4, 2026",
    dateOfStatementLabel: "July 5, 2026",
    purchaserName: "Elena Hernandez",
    purchaserPhone: "(954) 555-0188",
    purchaserEmail: "elena.hernandez@example.com",
    serviceCharges: {
      id: "services-selected",
      title: "A. Charge for Services Selected",
      totalLabel: "Director review required",
      lineItems: [
        {
          id: "basic-services",
          label: "Basic services of funeral director and staff",
          amountLabel: "Confirm from price list",
          source: "price_list",
          needsReview: true,
        },
        {
          id: "visitation-facility",
          label: "Use of facilities and staff for viewing / visitation",
          amountLabel: "Confirm from service plan",
          source: "family_selection",
          needsReview: true,
        },
        {
          id: "funeral-ceremony",
          label: "Use of facilities and staff for funeral ceremony",
          amountLabel: "Confirm from service plan",
          source: "family_selection",
          needsReview: true,
        },
      ],
    },
    merchandiseCharges: {
      id: "merchandise-selected",
      title: "B. Charge for Merchandise Selected",
      totalLabel: "Director review required",
      lineItems: [
        {
          id: "classic-oak-tribute",
          label: "Classic Oak Tribute casket",
          amountLabel: "Confirm availability and price",
          source: "family_selection",
          needsReview: true,
        },
        {
          id: "monarch-gold-folder",
          label: "Monarch Gold service folders",
          amountLabel: "85 requested",
          source: "family_selection",
          needsReview: true,
        },
      ],
    },
    specialCharges: {
      id: "special-charges",
      title: "C. Special Charges",
      totalLabel: "$0 draft",
      lineItems: [
        {
          id: "direct-cremation",
          label: "Direct cremation",
          amountLabel: "Not selected",
          source: "director_entry",
          needsReview: false,
        },
      ],
    },
    cashAdvanceItems: {
      id: "cash-advance-items",
      title: "D. Cash Advance Items",
      totalLabel: "Needs director entry",
      lineItems: [
        {
          id: "clergy",
          label: "Clergy",
          amountLabel: "Not entered",
          source: "cash_advance",
          needsReview: true,
        },
        {
          id: "flowers",
          label: "Flowers",
          amountLabel: "Family requested peaceful garden spray",
          source: "cash_advance",
          needsReview: true,
        },
        {
          id: "cemetery",
          label: "Cemetery",
          amountLabel: "Cemetery to be confirmed",
          source: "cash_advance",
          needsReview: true,
        },
      ],
    },
    disclosures: [
      "Charges are draft only until Monarch confirms pricing, availability, and required disclosures.",
      "Families choose only the arrangements and goods they want unless an item is required by law, cemetery, or crematory.",
      "Embalming and other care charges require director review and written explanation when required for the selected service.",
      "The family receives the final statement only after director review.",
    ],
    acknowledgementRequired: true,
    missingFields: ["Cemetery name", "Clergy fee", "Purchaser signature", "Final GPL/CPL pricing"],
    emailRecipients: ["KSwab@monarchfuneralhome.com"],
  },
  aiSummary:
    "Elena Hernandez submitted an immediate-need Catholic service for Maria Elena Hernandez. The statement draft is ready for Karen review. Missing items: cemetery, clergy fee, purchaser signature, and final GPL/CPL pricing.",
  missingItems: [
    {
      id: "missing-officiant",
      label: "Confirm officiant",
      severity: "required",
      section: "Service details",
    },
    {
      id: "missing-pallbearers",
      label: "Add pallbearers",
      severity: "recommended",
      section: "Digital service folder",
    },
    {
      id: "missing-photo",
      label: "Upload final portrait photo",
      severity: "recommended",
      section: "Memorial hub",
    },
    {
      id: "missing-cemetery",
      label: "Confirm cemetery location",
      severity: "required",
      section: "Disposition",
    },
  ],
  directorNotes: [
    {
      id: "note-demo",
      createdAt: "2026-07-05T14:26:00.000Z",
      authorName: "WeHonor AI",
      body: "Suggested next step: text Elena with missing-item checklist and offer a 20-minute arrangement review call today.",
    },
  ],
};
